import { marked } from 'marked'
import sanitizer from 'dompurify'

export default {
  renderMarkdown (markdown) {
    const html = marked.parse(markdown)
    return sanitizer.sanitize(html, {})
  }
}
